const SemVer = require('../classes/semver')
const patch = (a, loose) => new SemVer(a, loose).patch
module.exports = patch



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/patch.js
// module id = 2455
// module chunks = 0